import React from "react";
import TestimonialList from "../../Components/TestimonialList";

const Testimonials = () => {
  return <TestimonialList />;
};

export default Testimonials;
